import React, { FC } from 'react';

import { CtaImageBox } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-about';

export const AboutIntroContainer: FC = () => {
  return (
    <CtaImageBox
      image={{
        src: '/project-love/assets/boom-1.jpg',
        alt: '',
        style: {
          objectFit: 'contain',
          objectPosition: 'bottom',
          background: '#FCFCFC',
        },
      }}
      title={lexemes.lxPageAboutIntroTitle(2014)}
      description={lexemes.lxPageAboutIntroDescription}
    />
  );
};
